angular.module('SpidApp')

.factory('StampService',
		['Stamp', 'Restangular',
function (Stamp,   Restangular) {
	var StampService = {
		getDenormalized: function () {
			return Restangular.all('stamps').getList()
		},
			
		allCountries: function () {
			return this.getDenormalized().then(function (stamps) {
				return _.chain(stamps).map(function (stamp) {
					return stamp.label_pays
				}).unique().value()
			})
		},
		
		allStamps: function () {
			return this.getDenormalized().then(function (stamps) {
				return _.chain(stamps).unique(function (stamp) {
					return stamp.code_affran + stamp.label_pays
				}).value()
			})
		},
		
		allFilteredBy: function (where) {
			if (!where) {
				throw 'StampService::allFilteredBy() - Missing parameters'
			}
			
			return this.getDenormalized().then(function (stamps) {
				return _.chain(stamps).filter(where).value()
			})
		}
	}

	return StampService
}])